import { rackingTypeAccessorConfig } from 'projectSections/designPanels/PanelModuleGrid/accessors/rackingType'
import { StudioSystemType } from 'types/global'
import { setRelativeTiltForModuleGrids } from '../../utils'
import { syncFastRackHiddenClampLandscapeWarning } from './FastRack'
import { FAST_RACK_DEFAULT_COLOUR, FAST_RACK_PREFERRED_RAILS_DEFAULT, getLandscapeGridNames } from './FastRackInputForm'

function applyFastRackFlushMount(system: StudioSystemType): void {
  system.moduleGrids().forEach((moduleGrid) => {
    if (moduleGrid.getPanelConfiguration() !== 'STANDARD') {
      rackingTypeAccessorConfig.set({ moduleGrid, value: 'STANDARD' })
    }
  })
  setRelativeTiltForModuleGrids(system, 0)
}

/**
 * Called when Fast Rack is applied to a system.
 * Forces flush mount (STANDARD racking, zero tilt) on all module grids.
 */
export function fastRackOnApply(system: StudioSystemType): void {
  if (!system.integration_json) {
    system.integration_json = {}
  }
  if (!system.integration_json.fastRack) {
    system.integration_json.fastRack = {}
  }
  if (system.integration_json.fastRack.preferredRails === undefined) {
    system.integration_json.fastRack.preferredRails = FAST_RACK_PREFERRED_RAILS_DEFAULT
  }
  if (system.integration_json.fastRack.componentColour === undefined) {
    system.integration_json.fastRack.componentColour = FAST_RACK_DEFAULT_COLOUR
  }

  system.moduleGrids().forEach((moduleGrid) => {
    rackingTypeAccessorConfig.set({ moduleGrid, value: 'STANDARD' })
  })
  setRelativeTiltForModuleGrids(system, 0)
}

/**
 * Called on every mounting tab sync while Fast Rack is selected.
 * Re-applies flush mount when new panel layouts default to single-tilt on low slopes.
 * Also syncs the hidden end clamp landscape warning based on current grid orientations.
 */
export function fastRackOnSync(system: StudioSystemType): void {
  const hiddenClampValue = (system.integration_json?.fastRack?.hiddenClamp as string) || 'yes'
  const landscapeNames = getLandscapeGridNames(system)

  applyFastRackFlushMount(system)

  syncFastRackHiddenClampLandscapeWarning(system.uuid, hiddenClampValue, landscapeNames)
}
